/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "home",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "none",
                "stroke": "#FFFFFF",
                "strokeMiterlimit": "10"
            },
            "home": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "26.6",
            "height": "22.8"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26.6 22.8", className: "home", width: this.props.width, height: this.props.height, style: this.props.home },
            _react2["default"].createElement("path", { className: "st0", d: "M13.3.7l-12 10.6h3v11h6V15h6v7.3h6v-11h3z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/home.js